
const Pricing = () => {
  return (
    <section>
          <div className="w3-row-padding w3-center w3-padding-64" id="pricing">
    <h2>PRICING</h2>
    <p>Choose a pricing plan that fits your needs.</p>
    <br />
    <div className="w3-third w3-margin-bottom">
      <ul className="w3-ul w3-border w3-hover-shadow">
        <li className="w3-theme">
          <p className="w3-xlarge">Basic</p>
        </li>
        <li className="w3-padding-16">
          <b>10GB</b> Storage
        </li>
        <li className="w3-padding-16">
          <b>10</b> Emails
        </li>
        <li className="w3-padding-16">
          <b>10</b> Domains
        </li>
        <li className="w3-padding-16">
          <b>Endless</b> Support
        </li>
        <li className="w3-padding-16">
          <h2 className="w3-wide">
            <i className="fa fa-usd" /> 10
          </h2>
          <span className="w3-opacity">per month</span>
        </li>
        <li className="w3-theme-l5 w3-padding-24">
          <button className="w3-button w3-teal w3-padding-large">
            <i className="fa fa-check" /> Sign Up
          </button>
        </li>
      </ul>
    </div>
    <div className="w3-third w3-margin-bottom">
      <ul className="w3-ul w3-border w3-hover-shadow">
        <li className="w3-theme-l2">
          <p className="w3-xlarge">Pro</p>
        </li>
        <li className="w3-padding-16">
          <b>25GB</b> Storage
        </li>
        <li className="w3-padding-16">
          <b>25</b> Emails
        </li>
        <li className="w3-padding-16">
          <b>25</b> Domains
        </li>
        <li className="w3-padding-16">
          <b>Endless</b> Support
        </li>
        <li className="w3-padding-16">
          <h2 className="w3-wide">
            <i className="fa fa-usd" /> 25
          </h2>
          <span className="w3-opacity">per month</span>
        </li>
        <li className="w3-theme-l5 w3-padding-24">
          <button className="w3-button w3-teal w3-padding-large">
            <i className="fa fa-check" /> Sign Up
          </button>
        </li>
      </ul>
    </div>
    <div className="w3-third w3-margin-bottom">
      <ul className="w3-ul w3-border w3-hover-shadow">
        <li className="w3-theme">
          <p className="w3-xlarge">Premium</p>
        </li>
        <li className="w3-padding-16">
          <b>50GB</b> Storage
        </li>
        <li className="w3-padding-16">
          <b>50</b> Emails
        </li>
        <li className="w3-padding-16">
          <b>50</b> Domains
        </li>
        <li className="w3-padding-16">
          <b>Endless</b> Support
        </li>
        <li className="w3-padding-16">
          <h2 className="w3-wide">
            <i className="fa fa-usd" /> 50
          </h2>
          <span className="w3-opacity">per month</span>
        </li>
        <li className="w3-theme-l5 w3-padding-24">
          <button className="w3-button w3-teal w3-padding-large">
            <i className="fa fa-check" /> Sign Up
          </button>
        </li>
      </ul>
    </div>
  </div>
    </section>
  )
}

export default Pricing